import type { GQL_ID, NestedFilter } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

export interface ProductInfoInput {
  status?: number | null
  productGroup?: GQL_ID
  replaceProductGroup?: boolean
  productCategory?: GQL_ID
  productMarketingLabel?: GQL_ID | null
  replaceProductMarketingLabel?: boolean
}


export interface BulkUpdateProductsVariables {
  filter: NestedFilter
  productInfo: ProductInfoInput
}

export const GQL_MUTATION_BULK_UPDATE_PRODUCTS = gql`
  mutation bulkUpdateProducts ($filter: NestedFilterInput!, $productInfo: BulkUpdateProductInput!) {
    bulkUpdateProducts(filter: $filter, productInfo: $productInfo)
  }
`

export const useMutateBulkUpdateProducts = () => {
  return useMutation<boolean, BulkUpdateProductsVariables>(
    GQL_MUTATION_BULK_UPDATE_PRODUCTS
  )
}
